/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BADGE_TYPE_OUTLINE, Badge } from '@squiz/sds';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../../../Constants/Strings.constants';
import { EntityComponentSetItem } from '../../../../Services/component';
import { COMPONENT_SET_DETAILS_DATA_IDS } from '../../ComponentSetDetails.constants';

/**
 * Component set details description.
 */
export const ComponentSetDetailsDescription = (props: EntityComponentSetItem): JSX.Element => {
  const { t } = useTranslation();
  const { description, components, webPath } = props;

  const labels = {
    components: t(COMPONENT_SERVICE_STRINGS.components),
    instances: t(COMPONENT_SERVICE_STRINGS.instances),
    legacy: t(COMPONENT_SERVICE_STRINGS.legacy),
  };

  const stats = {
    components: Object.keys(components).length,
    instances: 0,
    legacy: 0,
  };

  return (
    <div className="component-set-details">
      <span className="component-set-details__webpath">{webPath}</span>
      <div className="component-set-details__description" data-id={COMPONENT_SET_DETAILS_DATA_IDS.setDescription}>
        <span>{description}</span>
        <div className="component-set-details__description-footer">
          {/* Instance Count - TODO: Temporarily Removed, functionality does not yet exist in Components API,
          expected to be added back in when work is completed in future.
          <Badge left={String(stats.instances)} type={BADGE_TYPE_OUTLINE} /> {labels.instances}
          <span className="component-set-details__separator" />
         */}
          {/* Component Count */}
          <Badge left={String(stats.components)} type={BADGE_TYPE_OUTLINE} /> {labels.components}
          {/* Legacy Count TODO:  Temporarily Removed, functionality does not yet exist in Components API,
          expected to be added back in when work is completed in future.
          <span className="component-set-details__separator" />
          <Badge left={String(stats.legacy)} type={BADGE_TYPE_OUTLINE} /> {labels.legacy} */}
        </div>
      </div>
    </div>
  );
};
